import { Injectable } from '@angular/core';
import { ContextService } from './context.service';
import { SessionService } from './session.service';
import { Location } from '@angular/common';
import { PublicExecutiveSession, SessionMobile, WCSession } from '../shared/interfaces/sessions';
import { environment } from 'src/environments/environment';

/**
 * Class created for the purpose as helpers for obtaining the context of a specific runtine
 */
@Injectable({
    providedIn: 'root'
})
export class SetInitialSessionService {

  public wc: boolean;

  constructor(
    private sessionService: SessionService,
    private contextService: ContextService,
    private location: Location
  ) {}

  /**
   *
   * @param sessionInfo optional | will only exist if it was called from a web component, otherwise the session info gets
   * extracted from somewhere else
   */
  public setSession(sessionInfo?: WCSession) {
    this.contextService.isWC() ? this.setSessionAsWC(sessionInfo) : this.setSessionWeb();
  }

  private setSessionAsWC(sessionInfo: WCSession) {
    this.sessionService.sessionAccountType = sessionInfo.sessionAccountType;
    this.sessionService.sessionPlatform = sessionInfo.sessionPlatform;
    this.sessionService.isJointAccount = sessionInfo.isJointAccount;
    this.sessionService.setIntention(sessionInfo.sessionAccountType);
  }

  private setSessionWeb() {
    if (this.contextService.isExecutiveMode()) {
      const sessionInfo = this.getSessionInfoFromUrl();
      this.sessionService.setPublicExecutiveSession(sessionInfo);
    } else {
      const accountUrlName = this.getAccountTypeFromUrl();
      this.sessionService.setIntention(accountUrlName);
      const accountType = this.accountUrlHomologate(accountUrlName);
      if (this.isCorrectAccountType(accountType)) {
        this.sessionService.setPublicClientSession(accountType);
      }
    }
  }

  /**
   * Gets session info that was set and encrypted through url
   * this option only works on Public Executive
   */
  private getSessionInfoFromUrl(): PublicExecutiveSession {
    const session = window.location.href.split('session=')[1];
    return JSON.parse(decodeURIComponent(atob(session)));
  }

  /**
   * Get account type from URL in Public Client mode
   */
  private getAccountTypeFromUrl() {
    const url: string = this.location.normalize(this.location.path());
    const allowedUrlAccountTypes: string[] = environment.accountOpeningParams.allowedUrlAccountTypes;
    const flowFastTrack = 'fast-track';
    if (url.includes(flowFastTrack)) {
      const cookieAccountType = this.contextService.getCookie('accountType');
      return allowedUrlAccountTypes.includes(cookieAccountType) ? cookieAccountType : allowedUrlAccountTypes[1];
    } else {
      return url.includes(allowedUrlAccountTypes[0]) ? allowedUrlAccountTypes[0] : allowedUrlAccountTypes[1];
    }
  }

  public setSessionMobile(sessionInfo: SessionMobile, accountType) {
    this.sessionService.setIntention(accountType);
    accountType = this.accountUrlHomologate(accountType);
    this.sessionService.setMobileSession(sessionInfo, accountType);
  }

  private isCorrectAccountType = (accountType: string): boolean => environment.accountOpeningParams.allowedAccountTypes.includes(accountType);

  private accountUrlHomologate(accountType) {
    /* if (environment.accountNormalize[accountType] === undefined) {
      this.store.dispatch(StepsNotClientActions.StepPlatformError());
    } */
    console.log('env account normalize', environment.accountNormalize[accountType]);
    return environment.accountNormalize[accountType];
  }
}
